export default __webpack_public_path__ + "static/media/Paste.119e766a.svg";